<div class="container">
  <mat-table [dataSource]="transactions" class="content" *ngIf="!loadingTransaction">
    <ng-container matColumnDef="code">
      <mat-header-cell *matHeaderCellDef>{{
        transactionExpandedLabels.code
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-cell">
        <span *ngFor="let item of element.points">{{ item.pointCode }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="serial">
      <mat-header-cell *matHeaderCellDef>{{
        transactionExpandedLabels.printerSerial
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-cell">
        <span *ngFor="let item of element.points">{{ item.equipmentSerial }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="points">
      <mat-header-cell class="points-column" *matHeaderCellDef>
        <span class="points-span">{{ transactionExpandedLabels.points }}</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="flex-cell points-column">
        <span *ngFor="let item of element.points" class="points-span">{{ item.quantity | number:'': language }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="addedby">
      <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.labelBy }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="user-data"
          [matTooltip]="(element.userName.length > 20) ? element.userName : ''" 
          matTooltipClass="name-tooltip" *ngIf="element.transactionType !== transactionTypes.PORT">{{ element.userName }} </span> 
        <ng-container *ngIf="element.transactionType === transactionTypes.PORT">{{ transactionExpandedLabels.portPrinters }} </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="expiresOn">
      <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.expiresOn }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span> {{element.expirationDate | date: dateFormat : 'UTC' : language}}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <mat-spinner
    *ngIf="loadingTransaction"
    class="loading"
    diameter="50"
  ></mat-spinner>
</div>
